import 'slick-carousel';
import debounce from './debounce';

$(() => {
  const $teamSlider = $('.yco-team-slider');

  if (!$teamSlider.length) {
    return;
  }

  const teamSliderOptions = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: false,
    prevArrow: '<em class="icon-arrow-left slick-arrow--prev"></em>',
    nextArrow: '<em class="icon-arrow-right slick-arrow--next"></em>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  if (window.matchMedia('(max-width: 767px)').matches) {
    $teamSlider.slick(teamSliderOptions);
  }

  $(window).resize(debounce(() => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      if (!$teamSlider.hasClass('slick-initialized')) {
        $teamSlider.slick(teamSliderOptions);
      }
    } else {
      if ($teamSlider.hasClass('slick-initialized')) {
        $teamSlider.slick("unslick");
      }
    }
  }, 200));
});



// WEBPACK FOOTER //
// ./assets/scripts/team_slider.js